import * as THREE from 'three'
import { types } from 'mobx-state-tree'
import { generateNodeType } from 'src/api/models/utils/generateNodeType'
import { adapter, adapterEdge } from 'src/constants/typenames'
import { AdapterPlateConnection } from 'src/api/models/Enclosure/Adapter/AdapterPlate'
import { IAdapter, IAdapterEdge } from './types'

export const Adapter: IAdapter = generateNodeType(adapter)
  .props({
    plates: types.optional(AdapterPlateConnection, {} as any)
  })
  .views(self => {
    return {
      get boundings() {
        const points = self.plates.edges.reduce((prev, edge) => {
          return [...prev, edge.properties.boundings.min, edge.properties.boundings.max]
        }, [] as THREE.Vector3[])
        const boundings = new THREE.Box3().setFromPoints(points)
        return boundings
      }
    }
  })

export const AdapterEdge = (): IAdapterEdge =>
  generateNodeType(adapterEdge).props({ node: types.optional(Adapter, {} as any) })
